var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPoloShirt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.091 4.777l-.099-.117-.093.117-.628.703v.095l-.22.276-.002 3.54h1.898v-3.54l-.22-.276V5.48l-.636-.703zm-.07-.526h.115L16.606 1h-5.227l2.475 3.25h-.001a.493.493 0 01.17 0h-.001zm1.313 1.068l2.662-3.51-.835-.541-2.33 2.992.503 1.059zM27 8.018l-5.904-5.264-3.236-.444-2.208 2.97-.002 4.03a.565.565 0 01-.548.576h-1.99a.564.564 0 01-.551-.576V5.53a.639.639 0 01-.083-.088L10.13 2.316l-3.242.42L1 7.986l3.798 3.947.048.054 1.058-1.102V26h16.165V15.571a.5.5 0 010-.133v-4.62l1.094 1.143L27 8.018zm-7.12 7.11a.049.049 0 01-.048.052h-2.374a.051.051 0 01-.051-.053v-3.865h2.48l-.006 3.865zm-6.573-10.93L10.97 1.205l-.835.542 2.669 3.509.502-1.058z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}

export default SvgPoloShirt;